export function normalizeCityName(name: string | undefined): string | undefined {
  if (!name || typeof name !== 'string') return name;
  // Lowercase, trim, remove unicode diacritics, and strip spaces so names are safe for URLs/keys
  try {
    const normalized = name
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '')
      .replace(/[^a-z0-9-]/g, '');
    return normalized;
  } catch (e) {
    // Fallback to simple replacements for Scandinavian letters
    return name.toLowerCase().trim()
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/å/g, 'a')
      .replace(/\s+/g, '')
      .replace(/[^a-z0-9-]/g, '');
  }
}

export function getCacheKeyForCity(name: string | undefined): string {
  const n = normalizeCityName(name) || '';
  return `weather_${n}`;
}
